// extracted by mini-css-extract-plugin
export default {"spinnercontainer":"LoadingSpinner_spinnercontainer__9e-oS","spinner":"LoadingSpinner_spinner__f1ZDk"};